import { render } from "./MainNavV2.vue?vue&type=template&id=84a9c620"
import script from "./MainNavV2.vue?vue&type=script&lang=js"
export * from "./MainNavV2.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__